/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgMultiClass = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M12 2c1.654 0 3 1.346 3 3a3.006 3.006 0 0 1-2 2.828V11h7v5.172c1.164.413 2 1.525 2 2.828 0 1.654-1.346 3-3 3s-3-1.346-3-3c0-1.304.836-2.416 2-2.829V13h-5v3.172c1.164.413 2 1.525 2 2.828 0 1.654-1.346 3-3 3s-3-1.346-3-3c0-1.304.836-2.416 2-2.829V13H6v3.172c1.164.413 2 1.525 2 2.828 0 1.654-1.346 3-3 3s-3-1.346-3-3c0-1.304.836-2.416 2-2.829V11h7V7.829A3.006 3.006 0 0 1 9 5c0-1.654 1.346-3 3-3zm0 16a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm7 0a1.001 1.001 0 0 0 0 2 1.001 1.001 0 0 0 0-2zM5 18a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm7-14a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgMultiClass as MultiClass };
